import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';

const FOOTER_LINKS = [
  { label: 'User Manual', to: '/manual' },
  { label: 'Terms of Service', to: '/terms-of-service' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Login', to: '/login' },
  { label: 'Lox and Loaded', to: '/lox-and-loaded' },
  { label: 'Shot Diagnostics', to: '/shot-diagnostics' },
];

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="container footer__top">
        <Link to="/#top" className="nav__brand">
          <img src={logo} alt="" className="nav__mark" />
          <span className="nav__brand-text">
            <span className="nav__word">RANGE DRILLS</span>
            <span className="nav__tagline">Shoot Better. Hit Your Mark.</span>
          </span>
        </Link>

        <nav className="footer__nav">
          {FOOTER_LINKS.map((link) => (
            <Link key={link.to} to={link.to}>
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="footer__contact">
          <span>Contact</span>
          <a href="mailto:info@rangedrills.io">info@rangedrills.io</a>
          <a
            href="https://www.instagram.com/rangedrillsio"
            target="_blank"
            rel="noopener noreferrer"
          >
            @rangedrillsio
          </a>
        </div>
      </div>
      <div className="container footer__bottom">
        <span>© 2026 Range Drills. Developed by iDoDev LLC. All rights reserved.</span>
        <span style={{ display: 'block', marginTop: '4px' }}>Patent Pending.</span>
      </div>
    </footer>
  );
}
